import { styled, TableCell, tableCellClasses } from "@mui/material";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        textAlign: "center",
        borderLeft: "1px solid rgba(224, 224, 224, 0.3)",
    },
    [`&.${tableCellClasses.head}:first-of-type`]: {
        left: 0,
        top: 0,
        zIndex: 10,
        borderRight: "1px solid rgba(224, 224, 224, 0.3)",
        minWidth: 300,
    },
    [`&.${tableCellClasses.head}:nth-of-type(2)`]: {
        borderLeft: "unset",
    },
    [`&.${tableCellClasses.body}`]: {
        padding: `0`,
    },
    [`th&.${tableCellClasses.body}`]: {
        borderRight: "1px solid rgba(224, 224, 224, 1)",
        position: "sticky",
        left: 0,
        zIndex: 5,
        backgroundColor: "inherit",
    },
    [`td&.${tableCellClasses.body}`]: {
        borderLeft: "1px solid rgba(224, 224, 224, 1)",
    },
    [`td&.${tableCellClasses.body}:first-of-type`]: {
        borderLeft: "unset",
    },
}));

export default StyledTableCell;
